export interface State {
  currentStepIndex: number;
  maxStepIndex: number;
}

export const initialState: State = {
  currentStepIndex: null,
  maxStepIndex: null,
};
